import React, { useEffect, useState, useContext } from "react";
import Cookies from "js-cookie";
import { useLocation } from "react-router-dom";
import { getApiService } from "../services/ApiService";
import { GetPayLoad } from "../services/PayLoadStorage";
import CloseIcon from "../assets/images/icons/Close-icom.svg";
import { LanguageContext } from "../contexts/LanguageContext";
import { getCookieOptions } from '../utils/cookieUtils';

const GPPBanner = ({}) => {
  const [showBanner, setShowBanner] = useState(false);
  const { pageContent } = useContext(LanguageContext);
  const [genericContent, setGenericContent] = useState([]);
  const Payload = GetPayLoad("PayLoad");
  const [actualCarrier, setActualCarrier] = useState(Payload?.owning_carrier);

  const headers = {
    "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
    "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
    "X-Hps-Region": Payload?.region,
    "X-Hps-Carrier": Payload?.owning_carrier,
  };
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const location = useLocation();
  const guestPortalUrl = process.env.REACT_APP_GUEST_PORTAL_URL;
  const guestPortalCarrierNameKey = `REACT_APP_${Payload?.owning_carrier}_NAME`;
  const guestPortalCarrierName = process.env[guestPortalCarrierNameKey];
  const guestPortalTargetUrl = `${guestPortalUrl}/${guestPortalCarrierName}`;

  const [gppBannerImage, setGppBannerImage] = useState(null);
  //Set generic content from language context
  useEffect(() => {
    if (pageContent?.generic) {
      setGenericContent(pageContent.generic);
    }
  }, [pageContent]);

  // Show banner based on API rule value and cookie
  useEffect(() => {
    if (location.pathname !== "/" && location.pathname !== "/overview") {
      setShowBanner(false);
      return;
    }
    const cookieName = `enableGPPBanner_${Payload?.owning_carrier}`;
    const cookieValue = Cookies.get(cookieName);

    if (cookieValue === "true") {
      setShowBanner(true);
    } else if (!cookieValue) {
      const targetRuleValueUrl = process.env.REACT_APP_API_GET_PROGRAM_RULE_VALUE_ENDPOINT;
      getApiService(
        baseUrl,
        targetRuleValueUrl,
        { action: "ByCarrier", carrierCode: Payload?.owning_carrier },
        headers
      ).then((response) => {
          if (response?.data?.statusCode === 200) {
            const result = response.data.data;
            if (result.length !== 0 && result?.ENABLE_GPP_BANNER === "true") {
              Cookies.set(cookieName, "true", { expires: 7 }, getCookieOptions()); // cookie valid for 7 days
              setShowBanner(true);
            }
          }
        }).catch((error) => {
          console.log("Get rule value API Failure", error);
        });
    }
    
    const isConnectiCareCarrier = Cookies.get("isConnectiCareCarrier") || 'false';
    const connectiCareCarrier = Cookies.get("connectiCareCarrier") || null;
    // Override for ConnectiCare carriers
    if(isConnectiCareCarrier === 'true' && connectiCareCarrier === process.env.REACT_APP_CONNECTICARE_CARRIER_CODE){
      setActualCarrier(process.env.REACT_APP_CONNECTICARE_CARRIER_CODE);
    } else{
      setActualCarrier(Payload?.owning_carrier);
    }
    
    // Dynamically import the banner image based on owning carrier
    import("../assets/images/Illustrations/" +actualCarrier+"-promotional.svg").then((image) => {
        setGppBannerImage(image.default);  
    }).catch((err) => {
        setGppBannerImage(null);
    });

  }, [location.pathname]);

  const handleClose = () => {
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <>
    {showBanner &&  gppBannerImage && (
      <div className="promotional-banner mt-1">
        <div className="col-1.5 ms-2">
          {
            gppBannerImage ? (
              <img src={gppBannerImage} width={actualCarrier === 'XC' ? "80" : "55"} alt="Promo" />
            ) : (
              <></>
            )
          }
        </div>
        <div className="col-10.5 px-2 position-relative">
          <h4 className="fs-7 fw-semibold mt-1">
            {genericContent?.gpp_banner_intro}
          </h4>
          <h3 className="mt-1 fw-bold fs-small">
            {genericContent?.gpp_banner_portal_name}
          </h3>
          <p className="mb-2 fw-medium">
            {genericContent?.gpp_banner_skip_msg}
            <a
              href={`${guestPortalTargetUrl}`}
              target="_blank"
              className={`fw-semibold ${actualCarrier === 'Q5' ? 'gpp-banner-link-q5' : 'text-decoration-underline'}`}
            >
              {genericContent?.gpp_banner_click_here}
            </a>{" "}
            {genericContent?.gpp_banner_to_start_msg}
          </p>
          <img
            src={CloseIcon}
            alt="Close"
            className="position-absolute end-0 top-0 me-3 close-icon mt-2"
            onClick={handleClose}
          />
        </div>
      </div>
      )}
    </>
  );
};

export default GPPBanner;
